import { useNavigate } from 'react-router';
import { NotFoundError } from '@hookmyapp/observability/errors';
import { Button } from '@/components/ui/button';

/**
 * Error body for the super-admin detail pages. A 404 means the entity is gone
 * (deleted workspace/user/channel, stale link) — retrying can never succeed,
 * so it gets a back-to-list action instead of the retry control that every
 * other failure (5xx, network) keeps.
 */
export function DetailLoadError({
  error,
  entity,
  backTo,
  backLabel,
  onRetry,
}: {
  error: unknown;
  entity: string;
  backTo: string;
  backLabel: string;
  onRetry: () => void;
}) {
  const navigate = useNavigate();

  if (error instanceof NotFoundError) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <h2 className="text-xl font-semibold">{entity} not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          It may have been deleted, or the link is out of date.
        </p>
        <Button className="mt-4" onClick={() => navigate(backTo)}>
          {backLabel}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16">
      <h2 className="text-xl font-semibold">Failed to load data</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Something went wrong loading the admin panel. Please try again.
      </p>
      <Button className="mt-4" onClick={onRetry}>
        Retry Loading
      </Button>
    </div>
  );
}
